// extracted by mini-css-extract-plugin
module.exports = {"coupon":"CouponCode_coupon__FZAV1","content":"CouponCode_content__iexnv","button":"CouponCode_button__67bYW","input":"CouponCode_input__cWJUZ"};